import { motion } from "framer-motion";
import styled from "styled-components";
import Button from "../../../styles/Button.js";
import { sizing } from "../../../styles/variables.js";

export const Articles = styled.div`
   display: flex;
   justify-content: space-around;
   flex-wrap: wrap;
   margin-top: 3.4rem;
`;

export const Article = styled(motion.div)`
   /*width: 30%;*/
   width: 19rem;
   border-radius: 0 ${sizing.borderRadius3} ${sizing.borderRadius3};
   box-shadow: 0 4px 16px #dfdfdf;
   overflow: hidden;
   margin: 0 1rem 2.4rem;

   @media (max-width: 500px) {
      margin: 0 0.4rem 2.4rem;
   }

   .article-img {
      height: 9rem;
      object-fit: cover;
      object-position: center;
   }

   .article-text {
      margin-top: 0.5rem;
      margin-bottom: 1.2rem;
   }
`;

export const ArticleBody = styled.div`
   padding: 1rem;
`;

export const ArticleButton = styled(Button)`
   font-size: 0.9rem;
   box-shadow: 0 0 transparent;
   padding: 0.15rem 0.8rem;
   border-radius: 0 ${sizing.borderRadius4} ${sizing.borderRadius4};
`;
